<div *ngIf="order$ | async"
     class="mb-checkout-confirmation"
     data-cy="mb-checkout-confirmation">

  <!----------------------->
  <!-- ORDER NUMBER AREA -->
  <!----------------------->
  <div class="row no-gutters text-center">
    <div class="col-12 mb-checkout-confirmation-icon">
      <img src="assets/icons/svg/checkout-confirmation-tick.svg"
           title="Checkout confirmed"
           alt="Checkout confirmed"
           aria-label="Checkout confirmed"/>
    </div>

    <div class="col-12 mb-checkout-confirmation-message">
      {{ 'orderConfirmation.thankYou' | cxTranslate }}
    </div>

    <ng-container *ngIf="currentOrderType === orderType.REQUEST">
      <div class="col-12 mb-checkout-confirmation-order" data-cy="mb-checkout-confirmation-order-request-number">
        <strong>{{ 'orderConfirmation.requestNumber' | cxTranslate }} {{ order?.requestOrderCode}} </strong>
      </div>

      <div class="col-12 mb-checkout-confirmation-info">
        <span>{{ 'orderConfirmation.orderRequestSubtitle1' | cxTranslate: { email: order?.contactInformation?.email } }}</span>
        <br/>
        <span>{{ 'orderConfirmation.orderRequestSubtitle2' | cxTranslate }}</span>
      </div>
    </ng-container>

    <ng-container *ngIf="currentOrderType === orderType.ORDER">
      <div class="col-12 mb-checkout-confirmation-order" data-cy="mb-checkout-confirmation-purchase-order-number">
        <strong>{{ 'orderConfirmation.orderNumber' | cxTranslate }}  {{ order?.purchaseOrderCode }} </strong>
      </div>

      <div class="col-12 mb-checkout-confirmation-info">
        <span>{{ 'orderConfirmation.orderSubtitle' | cxTranslate }}</span>
      </div>
    </ng-container>

    <ng-container *ngIf="currentOrderType === orderType.MIXED">
      <div class="col-12 mb-checkout-confirmation-order">
        <div class="mb-3"><strong data-cy="mb-checkout-confirmation-mixed-purchase-order-number">{{ 'orderConfirmation.orderNumber' | cxTranslate }} {{ order?.purchaseOrderCode }}</strong></div>
        <strong data-cy="mb-checkout-confirmation-mixed-order-request-number">{{ 'orderConfirmation.requestNumber' | cxTranslate }}  {{ order?.requestOrderCode }} </strong>
      </div>

      <div class="col-12 mb-checkout-confirmation-info">
        <span>{{ 'orderConfirmation.orderSubtitle' | cxTranslate }}</span>
      </div>
    </ng-container>

    <div class="col-12 col-sm-4 mx-auto mt-3 mb-4">
      <button class="btn btn-block btn-primary mb-checkout-confirmation-home-btn text-initial"
              type="button"
              (click)="navigateToHome()">
        <strong>{{ 'mbcommon.continueShopping' | cxTranslate }}</strong>
      </button>
    </div>
  </div>

  <!--------------------->
  <!-- ORDER INFO AREA -->
  <!--------------------->
  <div class="row no-gutters mt-1 px-1 py-1 mb-checkout-confirmation-order-info">
    <div class="col-12 col-sm-6">
      <div class="row no-gutters">
        <div *ngIf="order?.contactInformation"
             class="col-12"
             data-cy="mb-checkout-confirmation-contact-details">
          <mb-checkout-information-tile [title]="'review.contactDetails'"
                                        [data]="order?.contactInformation"
                                        [type]="infoTypes.CONTACT_DETAILS"
                                        [isEditable]="false">
          </mb-checkout-information-tile>
        </div>
        <div *ngIf="order?.deliveryAddress"
             class="col-12"
             data-cy="mb-checkout-confirmation-shipping-address">
          <mb-checkout-information-tile [title]="'review.shippingAddress'"
                                        [data]="order?.deliveryAddress"
                                        [type]="infoTypes.ADDRESS"
                                        [isEditable]="false"
                                        [formRegion]="checkoutRegion">
          </mb-checkout-information-tile>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-6">
      <div class="row no-gutters">
        <ng-container *ngIf="isPurchaseCheckoutType">
          <div class="col-12" data-cy="mb-checkout-confirmation-shipment-method">
            <mb-checkout-information-tile [title]="'review.shipmentMethod'"
                                          [type]="infoTypes.SHIPMENT_METHOD"
                                          [isEditable]="false">
            </mb-checkout-information-tile>
          </div>
          <div *ngIf="order?.paymentDetails?.paymentMode"
               class="col-12"
               data-cy="mb-checkout-confirmation-payment-details">
            <mb-checkout-information-tile [title]="'review.paymentMethod'"
                                          [data]="order?.paymentDetails.paymentMode"
                                          [type]="infoTypes.PAYMENT_METHOD"
                                          [isEditable]="false"
                                          [formRegion]="checkoutRegion">
            </mb-checkout-information-tile>
          </div>

          <div class="col-12" data-cy="mb-checkout-confirmation-additional-info">
            <mb-checkout-information-tile [title]="'review.additionalInfo'"
                                          [data]="order?.paymentDetails"
                                          [type]="infoTypes.PAYMENT_ADDITIONAL_INFO"
                                          [isEditable]="false"
                                          [formRegion]="checkoutRegion"
                                          [poNumberLabelKey]="'review.poInternalRefNum'">
            </mb-checkout-information-tile>
          </div>
        </ng-container>
        <div *ngIf="order?.paymentDetails?.billingAddress"
             class="col-12"
             data-cy="mb-checkout-confirmation-billing-address">
          <mb-checkout-information-tile [title]="'review.billingInformation'"
                                        [data]="order?.paymentDetails?.billingAddress"
                                        [type]="infoTypes.ADDRESS"
                                        [isEditable]="false"
                                        [formRegion]="checkoutRegion"
                                        [vatIdLabelKey]="'address.vatId'">
          </mb-checkout-information-tile>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="order?.checkoutNotes"
       class="row no-gutters mt-4 px-1 py-1 mb-checkout-confirmation-order-info">
    <div class="col-12">
      <mb-checkout-information-tile [title]="'review.notes'"
                                    [data]="order?.checkoutNotes"
                                    [type]="infoTypes.NOTES"
                                    [isEditable]="false">
      </mb-checkout-information-tile>
    </div>
  </div>

  <!-------------------->
  <!-- CART INFO AREA -->
  <!-------------------->
  <div *ngIf="orderEntries"
       class="row no-gutters mt-5">
    <div class="col-12 mb-3 mb-checkout-confirmation-cart-headline">
      <strong>{{ 'mbcommon.yourCart' | cxTranslate }}</strong>
    </div>

    <div class="col-12">
      <mb-cart-details [isDisplayedInCartPage]="false"
                       [orderEntries]="orderEntries">
      </mb-cart-details>
    </div>
  </div>
</div>
